import React from "react";

const stages = [
  { stage: "Stage 1", desc: "Marketplace" },
  { stage: "Stage 2", desc: "Digital Twins" },
  { stage: "Stage 3", desc: "Make Friends, Talk, Chat, Collect Goodies / Gifts" },
  { stage: "Stage 4", desc: "Smart Contracts, Trade Virtually" },
  { stage: "Stage 5", desc: "AI enabled Remote Quality Check" },  
  { stage: "Stage 6", desc: "Immersive AR/VR Farming" },
];

const HorecaHubMetaverseStageTimeline = () => (
  <div className="mt-16 max-w-3xl mx-auto">
    <h2 className="text-2xl font-bold text-yellow-200 mb-2">🚀 Roadmap</h2>
    <div className="space-y-4">
      {stages.map((s, i) => (
        <div key={i} className="bg-black border border-green-700 shadow p-4 rounded-lg">
          <h3 className="font-bold text-gray-200">{s.stage}</h3>
          <p className="text-white">{s.desc}</p>
        </div>
      ))}
    </div>
  </div>
);

export default HorecaHubMetaverseStageTimeline;
